import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'
import Button from 'react-bootstrap/Button';

import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faPause} from '@fortawesome/free-solid-svg-icons'

import {SET_DISPLAY_TIME, SET_PLAYBACK_STATE } from '../state/uiActions'
import {SET_DISPLAY_TIME_FILTERING} from '../state/viewportItemActions'

// 10.5 hours: 
const timeMin = (new Date('2022-10-08T07:30:00')).getTime()
const timeMax = (new Date('2022-10-08T18:00:00')).getTime() 

// 1:   1 minute  video 
// 10: 10 minutes video  
const mapUpdateTimeGapMsec = 300 // 100 1000
const recordingLengthMinutes = 1.5  // 4.8 ;

//var firstMapUpdate = new Date().getTime()
//var lastTimerUpdate = new Date().getTime()
//var lastMapUpdate = new Date().getTime()  

export default function DisplayTimeOverlay(props) {
  const dispatch = useDispatch(); 

  const timeFrom = useSelector((state) => state.ui.displayTime.timeFrom) ;
  const timeTo = useSelector((state) => state.ui.displayTime.timeTo) ;
  const ts = new Date(timeTo) 
  const distSumKm = useSelector((state) => state.viewport.distSumKm) ;
  const playbackState = useSelector((state) => state.ui.playbackState) ;
  const trailTimeRef = useRef(timeMin)
  const firstTimerUpdateRef = useRef(new Date().getTime())
  const timeoutRef = useRef(null)

  const handleClick = () => {
    var pstate = 'playing'
    if (playbackState=='playing') pstate = 'paused'
    dispatch({ type: SET_PLAYBACK_STATE, playbackState: pstate })
    if (pstate='playing') timerUpdate()
  }  
  const timerUpdate = async () => { 
    if (trailTimeRef.current < timeMax && playbackState=='playing') {
      clearTimeout( timeoutRef.current )

      timeoutRef.current = setTimeout(() => {
        // var displayTime = store.getState().ui.displayTime
        const currtime = (new Date()).getTime()
        trailTimeRef.current = timeMin + ( (currtime - firstTimerUpdateRef.current) / (recordingLengthMinutes*60*1000)) * 10.5*60*60*1000

        // start over when finished: 
        if (trailTimeRef.current >= timeMax)  {
          setTimeout(() => {
            trailTimeRef.current = timeMin 
            firstTimerUpdateRef.current =  new Date().getTime()
            // TODO: merge SET_DISPLAY_TIME* actions
            dispatch( {type: SET_DISPLAY_TIME, 
              displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
            dispatch( {type: SET_DISPLAY_TIME_FILTERING, 
              displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} )               
            if (timeoutRef.current) clearTimeout( timeoutRef.current)
            timerUpdate()
          }, 1000)     
        }
        else {
          dispatch( {type: SET_DISPLAY_TIME, 
            displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
          dispatch( {type: SET_DISPLAY_TIME_FILTERING, 
            displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
          timeoutRef.current = null
          timerUpdate()
        }
        }, 100 // ( recordingLengthMinutes / 630 ) * 10000  //0.67*1000 
      )
    }
  }

  useEffect(() => {
    
    if (playbackState=='playing' ) timerUpdate()

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }

  }, [timeTo, playbackState])

  // HACK: 
  //if (isNaN(dkm) || (dkm < 19) ) dkm = 0
  var distString = Math.round(distSumKm).toLocaleString( "HU-hu", { minimumFractionDigits: 0 } ) ;


  var icon = faPlay ;
  if (playbackState=='playing') icon = faPause 
  return (
    <>
    <Button variant="secondary" className="playerOverlay monospace" 
            onClick={() => handleClick()} >
      <FontAwesomeIcon icon={icon} size="xl"/>
      <br/>
      <b>
      {"2022.10.08. " + String(ts.getHours()).padStart(2, '0') + 
       ":" + String(ts.getMinutes()).padStart(2, '0') + 
       ":" + String(ts.getSeconds()).padStart(2, '0') }
      </b><br/>
      {distString}  km<br/>
    </Button>
    </>
    //)
    //, document.getElementById('timerOverlay')
  ); 



}



